import classNames from 'classnames'
import { ELT_FORM_SECTION } from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Button, IButtonProps } from 'core-components/library/button'
import { Tooltip } from 'core-components/library/tooltip'

import { getFormedEltTranslation } from '../../../helpers/getFormedEltTranslation'

import styles from './ForceUpdate.module.scss'

interface IProps extends IButtonProps {
  onClick: (section: ELT_FORM_SECTION) => void
  section: ELT_FORM_SECTION
  isIcon?: boolean
}

export const ForceUpdate = ({ onClick, section, isIcon, ...other }: IProps) => {
  return null
  // if (isIcon) {
  //   return (
  //     <Tooltip tipContent={() => <Translation text={getFormedEltTranslation('force-update')} />}>
  //       <i
  //         onClick={() => onClick(section)}
  //         className={classNames('kbase kbase-reload', styles.icon)}
  //       />
  //     </Tooltip>
  //   )
  // }
  // return (
  //   <Button onClick={() => onClick(section)} {...other}>
  //     <Translation text={getFormedEltTranslation('force-update')} />
  //   </Button>
  // )
}
